import React, { Component } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { connect } from 'react-redux';
import { FormGroup, Label, Input } from 'reactstrap';

class EditModal extends Component {
    
    state = {
        firstName: "",
        lastName: "",
        institution: "",
        gender: "",
        address: "",
        contact: "",
        contactError: false
    }

    componentDidUpdate(prevProps) {
        if(this.props.show !== prevProps.show) {
            this.setState({
                firstName: this.props.firstName,
                lastName: this.props.lastName,
                institution: this.props.institute,
                gender: this.props.gender,
                address: this.props.address,
                contact: this.props.contact,
            })
        }
    }

    inputChangeHandler = (event, field) => {
        if(field === 'contact' && isNaN(event.target.value)) {
            return;
        }
        this.setState({
            [field]: event.target.value
        })
    }

    submitForm = async (event) => {
        event.preventDefault();
        if(this.state.contact.length !== 10) {
            this.setState({
                contactError: true
            })
            return;
        }
        // phone_no, u_coins, fname, lname, gender, address, inst_name, username, email_id
        const userData = {
            "username": this.props.username,
            "gender": this.state.gender,
            "phone_no": this.state.contact,
            "fname": this.state.firstName,
            "lname": this.state.lastName,
            "gender": this.state.gender,
            "address": this.state.address,
            "u_coins": this.props.coin,
            "inst_name": this.state.institution,
            "email_id": this.props.email
        };
        // console.log("userData", userData);
        await axios.post('https://server.codeium.tech/profile',userData).then(res => {
            // console.log(res);
        });
        // post request for updating details
        this.props.closeModal();
        window.location.reload();
    }

    render() {
        // console.log(this.props);
        return (
            <Modal className="EditingModal" centered  dialogClassName="EditModal" show={this.props.show} onHide={this.props.closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h2>
                           <b>Edit Profile</b>
                        </h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="row mb-4">
                    <div className="col-12 mx-auto">
                        <Form onSubmit={this.submitForm}>
                            <Form.Group controlId="formBasicText1">
                                <Form.Label className="font-weight-bold">First Name</Form.Label>
                                <Form.Control required onChange={(event) => this.inputChangeHandler(event, "firstName")} type="text" placeholder="Enter First Name" value={this.state.firstName} />
                            </Form.Group>
                            <Form.Group controlId="formBasicText2">
                                <Form.Label className="font-weight-bold">Last Name</Form.Label>
                                <Form.Control required onChange={(event) => this.inputChangeHandler(event, "lastName")} type="text" placeholder="Enter Last Name" value={this.state.lastName} />
                            </Form.Group>
                            <Form.Group required controlId="formBasicText3" onChange={(event) => this.inputChangeHandler(event, 'gender')}>
                                <Form.Label className="font-weight-bold">Gender</Form.Label>
                                <div className="row">
                                    <div className="col-3 ml-2">
                                        <FormGroup check>
                                            <Label check>
                                            <Input checked={this.state.gender === "Male"} value="Male" type="radio" name="radio2" />{' '}
                                                Male
                                            </Label>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup check>
                                            <Label check>
                                            <Input checked={this.state.gender === "Female"} value="Female" type="radio" name="radio2" />{' '}
                                                Female
                                            </Label>
                                        </FormGroup>
                                    </div>
                                </div>
                            </Form.Group>
                            <Form.Group controlId="formBasicText4">
                                <Form.Label className="font-weight-bold">Contact</Form.Label>
                                <Form.Control required onChange={(event) => this.inputChangeHandler(event, "contact")} type="text" placeholder="Enter Your Contact Number" value={this.state.contact} />
                                {
                                    this.state.contactError ? (
                                        <div class="invalid-feedback">
                                            Contact number should contain 10 digits
                                        </div>
                                    ) : null
                                }
                            </Form.Group>
                            <Form.Group controlId="formBasicText5">
                                <Form.Label className="font-weight-bold">Institute</Form.Label>
                                <Form.Control required onChange={(event) => this.inputChangeHandler(event, "institution")} type="text" placeholder="Enter Your Institute Name" value={this.state.institution} />
                            </Form.Group>
                            <Form.Group controlId="formBasicText6">
                                <Form.Label className="font-weight-bold">Address</Form.Label>
                                <Form.Control as="textarea" rows={4} required onChange={(event) => this.inputChangeHandler(event, "address")} type="text" placeholder="Enter Your Address" value={this.state.address}/>
                            </Form.Group>
                            
                            <Button variant="primary" block type="submit">
                                Submit
                            </Button>
                        </Form>
                    </div>
                </div>
                </Modal.Body>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        username: state.auth.username
    }
}

export default connect(mapStateToProps)(EditModal);